import * as constants from './dataAndBi.constants';
import * as reducerConstants from '../../constants/reducer.constants';

export const getIsUserFranchise = (state) => state.getIn(['app', 'franchisesData', 'franchises', 'userBusinessLocations', 'isFranchise']);

export const getConfig = (state) => state.getIn([reducerConstants.DATA_AND_BI, constants.DATA_EXPORT, constants.CONFIG]);
export const getFiles = (state) => state.getIn([reducerConstants.DATA_AND_BI, constants.DATA_EXPORT, constants.FILES_DATA]);
export const getSignedUrl = (state) => state.getIn([reducerConstants.DATA_AND_BI, constants.DATA_EXPORT, constants.SIGNED_URL]);
export const getActivated = (state) => state.getIn([reducerConstants.DATA_AND_BI, constants.DATA_EXPORT, constants.ACTIVATE]);
